import { render, staticRenderFns } from "./InvitationTaskList.vue?vue&type=template&id=2b0e2a18&scoped=true"
import script from "./InvitationTaskList.vue?vue&type=script&lang=js"
export * from "./InvitationTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0e2a18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b0e2a18')) {
      api.createRecord('2b0e2a18', component.options)
    } else {
      api.reload('2b0e2a18', component.options)
    }
    module.hot.accept("./InvitationTaskList.vue?vue&type=template&id=2b0e2a18&scoped=true", function () {
      api.rerender('2b0e2a18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/systemSet/InvitationTaskList.vue"
export default component.exports